import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Card, Grid, Typography, Chip, IconButton
} from '@mui/material';
import {
  Button
} from '@material-ui/core';

import Avatar from 'src/components/extended/Avatar'
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Profile from 'src/components/account-profile/Profile1';
import DialogTitle from '@mui/material/DialogTitle';
const avatarImage = require.context('src/assets/images/users', true);
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import EmployeeCard from 'src/components/cards/EmployeeCard';
import Slide from '@mui/material/Slide';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

// ==============================|| USER DETAILS CARD ||============================== //

const UserDetailsCard = ({ about, avatar, contact, email, location, name, role, status, id, OrganizationTypeId, serviceShopId, StatusId, NameParam, SurnameParam, DealerGroup }) => {
  const theme = useTheme();
  // const avatarProfile = avatar && avatarImage(`./${avatar}`);

  const [gridSpacing, setgridSpacing] = useState(1);
  const [openEditPopUp, setOpenEditPopUp] = useState(false);
  const [OpenShowPopUp, setOpenShowPopUp] = useState(false);


  return (
    <Card
      sx={{
        p: 2,
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
        border: theme.palette.mode === 'dark' ? '1px solid transparent' : `2px solid${theme.palette.grey[100]}`,
        '&:hover': {
          borderColor: '#FF9800'//arçelik sarı
        }
      }}

    >
      <Grid container spacing={gridSpacing} style={{ minHeight: 320, maxHeight: 320 }}>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={4} alignItems={'left'}>
              <Avatar alt={name} size="lg" src={avatar}
                style={{
                  width: theme.spacing(6),
                  height: theme.spacing(6),

                }}
              />
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'center' }} >
              {/* {Kvkk === 1 ? (
                <VerifiedUserIcon style={{ color: 'green' }} />
              ) : (
                <VerifiedUserIcon style={{ color: 'red' }} title="Bu kullanıcı Kvkk izni vermemiştir!..." />
              )} */}
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right' }} zeroMinWidth>
              {status === "Aktif" ? (
                <Chip
                  label="Aktif"
                  size="small"
                  // color="success"
                  style={{ backgroundColor: '#00C853', color: 'white' }}
                />
              ) : (
                <Chip
                  label="Pasif"
                  size="small"
                  style={{ backgroundColor: '#D84315', color: 'white' }}
                  sx={{
                    bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : 'error.light',
                    color: 'error.dark'
                  }}
                />
              )}
            </Grid>

          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4" component="div">
            {name}
          </Typography>
          <Typography variant="caption">{role}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2" sx={{ color: theme.palette.grey[700] }}>
            {about}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="caption">Email</Typography>
          <Typography variant="h6">{email}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={6}>
              <Typography variant="caption">Telefon</Typography>
              <Typography variant="h6">{contact}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption">Şehir</Typography>
              <Typography variant="h6">{location}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                fullWidth
                style={{ borderColor: '#FF9800', color: '#FF9800', textTransform: 'none' }}
                startIcon={<EditTwoToneIcon />}
                onClick={() => setOpenEditPopUp(true)}>
                Düzenle
              </Button>

            </Grid>
            <Grid item xs={6}>
              <Button variant="outlined"
                color="secondary"
                fullWidth
                style={{ textTransform: 'none' }}
                onClick={() => setOpenShowPopUp(true)}

                startIcon={<VisibilityTwoToneIcon />}>
                Göster
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        fullScreen
        open={openEditPopUp}
        TransitionComponent={Slide} // Slide geçiş efekti için TransitionComponent olarak Slide'ı kullanıyoruz
        TransitionProps={{
          direction: 'up', // Dialogun sağdan sola açılmasını sağlamak için direction prop'unu 'left' olarak belirliyoruz
        }}
        sx={{ '& .MuiDialog-paper': { maxHeight: 800, minHeight: 800 } }}
        onClose={() => setOpenEditPopUp(false)}
      >
        <DialogTitle
          size="small"
          id="responsive-dialog-title"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          Çalışan Detayı
          <IconButton
            edge="end"
            size="small"
            color="inherit"
            onClick={() => setOpenEditPopUp(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              top: '50%', // Yukarıdan %50 konumda
              right: '10', // Sağ kenarda
              transform: 'translateY(-50%)', // Dikey ortalamayı sağlar
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Profile EmployeeNr={id}
            OrganizationTypeId={OrganizationTypeId}
            ServiceShopId={serviceShopId}
            // Kvkk={Kvkk}
            // KvkkPhone={KvkkPhone}
            // KvkkEmail={KvkkEmail}
            Name={NameParam}
            Surname={SurnameParam}
            PersonelType={role}
            StateId={StatusId} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={OpenShowPopUp}
        onClose={() => setOpenShowPopUp(false)}

      >
        <EmployeeCard EmployeeNr={id} EmployeeName={name} EmployeeRole={role} EmployeeDealerGroup={DealerGroup} />
        <DialogActions>
          <Button onClick={() => setOpenShowPopUp(false)} autoFocus>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Card>

  );
};

UserDetailsCard.propTypes = {
  about: PropTypes.string,
  avatar: PropTypes.string,
  contact: PropTypes.string,
  email: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.number,
};

export default UserDetailsCard;
